import s from "react";
import { cls as d } from "../../helpers/cls.js";
import { forwardAsTagRef as _ } from "../../helpers/forwardAsTagRef.js";
import { Flex as l } from "../Flex/Flex.js";
var O = Object.defineProperty,
  u = Object.defineProperties,
  v = Object.getOwnPropertyDescriptors,
  n = Object.getOwnPropertySymbols,
  i = Object.prototype.hasOwnProperty,
  c = Object.prototype.propertyIsEnumerable,
  p = (r, e, t) => e in r ? O(r, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : r[e] = t,
  w = (r, e) => {
    for (var t in e || (e = {})) i.call(e, t) && p(r, t, e[t]);
    if (n) for (var t of n(e)) c.call(e, t) && p(r, t, e[t]);
    return r;
  },
  y = (r, e) => u(r, v(e)),
  b = (r, e) => {
    var t = {};
    for (var a in r) i.call(r, a) && e.indexOf(a) < 0 && (t[a] = r[a]);
    if (r != null && n) for (var a of n(r)) e.indexOf(a) < 0 && c.call(r, a) && (t[a] = r[a]);
    return t;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const D = _((r, e) => {
  const t = r,
    {
      type: a = "outlined",
      children: f,
      customDataDsComponent: o
    } = t,
    m = b(t, ["type", "children", "customDataDsComponent"]);
  return s.createElement(l, y(w({
    "data-ds-component": o != null ? o : "DS-Container"
  }, m), {
    ref: e,
    className: d(r.className, "olx-container", a && "olx-container--".concat(a))
  }), f);
});
l.displayName = "Flex";
export { D as Container };